import { COUNTRIES } from 'constants/countries';

export const getCountryLabelFromCode = (code?: string) => {
  if (!code || code === 'Unknown') {
    return 'Unknown';
  }
  return COUNTRIES.find(country => country.code === code.toUpperCase())?.label || 'Unknown';
};
